module.exports = __webpack_public_path__ + "img/technology_enterprise.551d00e8.png";